import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Users, Star, Clock, MessageCircle, Play } from 'lucide-react';
const WA_URL = `https://wa.me/584123555747?text=${encodeURIComponent('Hola, quiero comprar el Masterkit Elite. ¿Cómo pago por Pago Móvil?')}`;

// ── VIDEO CON CARGA DIFERIDA (evita que 2 iframes frenen la página) ────────
function VideoPlayer({
  videoId,
  title
}: {
  videoId: string;
  title: string;
}) {
  const [playing, setPlaying] = useState(false);
  const thumb = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  return <div className="aspect-video w-full rounded-2xl overflow-hidden bg-[#0a0a0a]" data-id="element-141">
      {playing ? <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`} title={title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-142" /> : <button onClick={() => setPlaying(true)} className="relative w-full h-full group cursor-pointer" aria-label={`Reproducir: ${title}`} data-id="element-143">
          <img src={thumb} alt={title} className="w-full h-full object-cover" data-id="element-144" />
          <div className="absolute inset-0 bg-black/45 group-hover:bg-black/30 transition-colors duration-200" data-id="element-145" />
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-146">
            <div className="w-16 h-16 bg-white/95 group-hover:bg-white group-hover:scale-110 rounded-full flex items-center justify-center shadow-2xl transition-all duration-200" data-id="element-147">
              <Play className="w-6 h-6 text-black ml-1" fill="black" data-id="element-148" />
            </div>
          </div>
          <div className="absolute bottom-3 left-0 right-0 text-center" data-id="element-149">
            <span className="text-xs text-white/70 bg-black/40 px-3 py-1 rounded-full" data-id="element-150">
              ▶ Ver demo del Masterkit Elite
            </span>
          </div>
        </button>}
    </div>;
}
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 md:px-6 lg:px-8 w-full overflow-hidden" data-id="element-151">

      <div className="absolute top-0 left-0 w-full h-full pointer-events-none -z-10" data-id="element-152">
        <div className="absolute top-[-20%] left-[-10%] w-[60vw] h-[60vw] bg-cyan-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-153" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60vw] h-[60vw] bg-green-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-154" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-155">

        {/* ── COLUMNA IZQUIERDA ── */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-start text-left" data-id="element-156">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-cyan-400 text-sm font-semibold mb-6 tracking-wide uppercase" data-id="element-157">
            <span className="relative flex h-2 w-2" data-id="element-158">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75" data-id="element-159" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500" data-id="element-160" />
            </span>
            Versión 3.0 Ya Disponible
          </div>

          {/* ── H1 — CONECTA CON EL DOLOR DEL ANUNCIO GANADOR ── */}
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] tracking-tight mb-6" data-id="element-161">
            Si cobras en bolívares sin saber tu margen en dólares,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-400 to-amber-400" data-id="element-162">
              estás perdiendo plata todos los días.
            </span>
          </h1>

          {/* Subtítulo */}
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-8 font-light max-w-xl" data-id="element-163">
            El <strong className="text-white font-semibold" data-id="element-164">Masterkit Elite</strong> calcula exactamente cuánto cobrar según la tasa BCV del día. Inventario, costos, fiados y cierre de caja — todo en un archivo Excel para{' '}
            <strong className="text-white font-semibold" data-id="element-165">Minimarkets, Repuestos, Bodegas y Licorerías</strong>, sin pagar mensualidades.
          </p>

          {/* ── CTAs ── */}
          <div className="w-full sm:w-auto flex flex-col gap-3 mb-6" data-id="element-166">
            {/* CTA Principal — Checkout web */}
            <a href="#comprar" className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-green-500 to-cyan-500 hover:from-green-400 hover:to-cyan-400 text-black font-black text-lg md:text-xl rounded-xl text-center transition-all duration-300 shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_40px_rgba(34,197,94,0.5)] uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-167">
              <Download className="w-6 h-6" data-id="element-168" />
              Obtener por solo $24.99
            </a>

            {/* CTA Secundario — WhatsApp (prominente, casi igual al principal) */}
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-3.5 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 hover:border-[#25D366]/60 text-[#25D366] font-bold text-base rounded-xl text-center transition-all duration-200 flex items-center justify-center gap-2" data-id="element-169">
              <MessageCircle className="w-5 h-5 flex-shrink-0" data-id="element-170" />
              Pagar con Pago Móvil por WhatsApp
            </a>
          </div>

          {/* Prueba social */}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-171">
            <div className="flex items-center gap-1.5 text-sm text-gray-400 font-medium" data-id="element-172">
              <ShieldCheck className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-173" />
              <span data-id="element-174">Único pago de por vida</span>
            </div>
            <span className="text-white/15 hidden sm:block" data-id="element-175">|</span>
            <div className="flex items-center gap-1.5 text-sm text-gray-400 font-medium" data-id="element-176">
              <Users className="w-4 h-4 text-cyan-400 flex-shrink-0" data-id="element-177" />
              <span data-id="element-178">87+ negocios activos</span>
            </div>
            <span className="text-white/15 hidden sm:block" data-id="element-179">|</span>
            <div className="flex items-center gap-1.5 text-sm text-gray-400 font-medium" data-id="element-180">
              <Star className="w-4 h-4 text-yellow-400 flex-shrink-0" data-id="element-181" />
              <span data-id="element-182">4.9/5 valoración</span>
            </div>
            <span className="text-white/15 hidden sm:block" data-id="element-183">|</span>
            <div className="flex items-center gap-1.5 text-sm text-gray-400 font-medium" data-id="element-184">
              <Clock className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-185" />
              <span data-id="element-186">Entrega en menos de 5 min</span>
            </div>
          </div>
        </motion.div>

        {/* ── COLUMNA DERECHA: VIDEO (carga diferida) ── */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end group lg:ml-10 mt-10 lg:mt-0" data-id="element-187">
          <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/20 to-green-500/20 rounded-3xl blur-[40px] group-hover:blur-[60px] transition-all duration-500" data-id="element-188" />
          <div className="relative w-full max-w-sm md:max-w-xl rounded-3xl overflow-hidden border border-cyan-500/30 shadow-[0_0_60px_rgba(34,211,238,0.25)] bg-[#0a0a0a] p-2" data-id="element-189">
            <VideoPlayer videoId="dSrultJNhdQ" title="Demo Masterkit Elite" data-id="element-190" />
          </div>
        </motion.div>

      </div>
    </section>;
}